import React from 'react';
import { KalenderBegivenhed } from '../../types';
import UpcomingCard from './UpcomingCard';
import styles from './UpcomingList.module.scss';

interface UpcomingListProps {
  begivenheder: KalenderBegivenhed[];
  max?: number;
}

const UpcomingList: React.FC<UpcomingListProps> = ({ begivenheder, max }) => {
  const liste = max ? begivenheder.slice(0, max) : begivenheder;

  if (liste.length === 0) {
    return (
      <div className={styles.empty}>
        <p>Ingen kommende begivenheder inden for de næste dage.</p>
      </div>
    );
  }

  return (
    <ul className={styles.list}>
      {liste.map((begivenhed) => (
        <li key={begivenhed.id}>
          <UpcomingCard begivenhed={begivenhed} />
        </li>
      ))}
    </ul>
  );
};

export default UpcomingList;
